<template>
  <div>
    <SortableList @input="sortFun" lockAxis="y" v-model="completed">
      <SortableItem class="m-b-15" v-for="(item, index) in completed" :key="index + 10000" :index="index">
        <b-input-group style="margin-bottom: 0;">
          <div class="input-group-prepend" style="width: 36px;cursor: n-resize;">
            <div class="input-group-text w-100 up-video-progress-bar" style="background: #ccc; border-color: #ccc;">
              <div class="up-video-progress-success" style="width: 100%;">
                <i class="fa fa-check fa-lg m-t-10" style="color: #fff;"></i>
              </div>
            </div>
          </div>
          <b-form-input v-model="item.fileName" @input="inputChange" maxlength="30" :style="{'border-color': errors.first('video_input' + index) ? '#ef5350' : ''}" placeholder="请输入章节名称..." :name="'video_input' + index" v-validate="'required|length'"></b-form-input>
          <b-input-group-append>
            <b-btn variant="danger" @click="successDel(item, index)" style='z-index:0'>删除</b-btn>
          </b-input-group-append>
        </b-input-group>
        <span class="control-label" :class="{'color-danger':errors.has('video_input' + index)}">{{errors.first('video_input' + index) | errorFilter('视频名称！')}}</span>
      </SortableItem>
    </SortableList>

    <template v-for="(item, index) in uploading">
      <b-input-group v-if="!item.isSuccess && !item.remove" :key="index">
        <div class="input-group-prepend" style="width: calc(100% - 54px);">
          <div class="input-group-text w-100 up-video-progress-bar" style="background: #ccc; border-color: #ccc;">
            <div class="up-video-progress-uploading" :style="{width: item.fileCurr * 100 + '%'}"></div>
            <span class="name">
              {{item.fileName}}
              <span v-if="item.fileMsg">（上传失败：{{item.fileMsg}}）</span>
              <span ref="uploadingSpan" v-if="!item.isSuccess && !item.fileMsg">（上传中  {{Math.round(item.fileCurr * 100)}}%）</span>
            </span>
          </div>
        </div>
        <b-input-group-append>
          <b-btn variant="danger" @click="cancelUp(item, index)" style='z-index:0'>删除</b-btn>
        </b-input-group-append>
      </b-input-group>
    </template>

    <label :for="id" class="input-up-video pointer db">
      <div class="upload_warp_right text-center pointer p-t-20" style="padding-bottom: 15px;">
        <img class="mauto db m-b-5" style="max-width: 64px;width: 40%;" src="./upload.png">
        <input type="file" :id="id" :name="id" multiple style="display: none;" @change="upVideo">
        点击上传视频
      </div>
    </label>
  </div>
</template>

<script>
  import OpenService from 'service/open-service'
  export default {
    data () {
      return {
        uploading: [], // 上传中
        callback: '', // 签名
        completed: []
      }
    },
    props: {
      id: {
        type: String,
        default: 'up_video'
      },
      videoInit: {
        type: Array,
        default: () => []
      }
    },
    watch: {
      videoInit (e) {
        this.completed = e
      },
      completed (e) {
        this.$emit('change', e)
      }
    },
    created () {
      this.$validator.remove('length')
      this.$validator.extend('length', {
        getMessage (f, p, d) {
          return (d && d.message) || '视频名称长度不得超过30个字！'
        },
        validate: (v) => {
          if (v.length <= 30) {
            return true
          } else {
            return false
          }
        }
      })
    },
    methods: {
      uploadVideo (file, i) {
        this.uploading.push({file: file, fileType: '', fileName: file.name, fileCurr: '', fileCos: '', fileTaskId: '', fileMsg: '', remove: false, isSuccess: false, id: ''})
        let _this = this
        var resultMsg = window.qcVideo.ugcUploader.start({
          videoFile: file, // 视频，类型为 File
          getSignature (callback) { // 获取签名
            callback(_this.callback)
          },
          success (result) {
            _this.$awn.success(_this.uploading[i].fileName + '上传成功！')
          },
          error (result) {
            _this.uploading[i].fileType = result.type // 上传失败的文件类型
            _this.uploading[i].fileMsg = result.msg // 上传失败的原因
          },
          progress (result) {
            _this.uploading[i].fileType = result.type // 上传进度的文件类型
            _this.uploading[i].fileName = result.name // 上传进度的文件名称
            _this.uploading[i].fileCurr = result.curr // 上传进度
            _this.uploading[i].fileCos = result.cos // 取消上传识别
            _this.uploading[i].fileTaskId = result.taskId // 取消上传识别
          },
          finish (result) {
            _this.uploading[i].fileId = result.fileId
            _this.uploading[i].videoUrl = result.videoUrl
            _this.completed.push(_this.uploading[i])
            setTimeout(() => {
              _this.$validator.validateAll().then(res => {
                _this.$emit('success', res)
              })
            }, 50)
            _this.uploading[i].isSuccess = true
          }
        })
        if (resultMsg) {
          this.uploading[i].remove = true
          this.$awn.alert('必须上传视频文件！视频格式支持：WMV、WM、ASF、ASX、RM、RMVB、RA、RAM、MPG、MPEG、MPE、VOB、DAT、MOV、3GP、MP4、MP4V、M4V、MKV、AVI、FLV、F4V')
        }
      },
      upVideo (e) { // 上传视频
        let length = this.uploading.length
        OpenService.vodSignature().then(res => {
          if (res.meta && res.meta.success) {
            this.callback = res.data.signature
            for (var i = length; i < length + e.target.files.length; i++) {
              this.uploadVideo(e.target.files[i - length], i)
            }
            e.target.value = ''
          } else {
            this.$awn.alert('获取签名失败！')
          }
        })
      },
      cancelUp (item, index) { // 取消上传
        item.remove = true
        window.qcVideo.ugcUploader.cancel({
          cos: item.fileCos,
          taskId: item.fileTaskId
        })
      },
      successDel (item, index) { // 上传成功删除
        this.completed.splice(index, 1)
        this.$emit('change', this.completed)
      },
      inputChange (e) {
        this.sortFun()
        setTimeout(() => {
          this.$validator.validateAll().then(res => {
            this.$emit('success', res)
          })
        }, 50)
      },
      sortFun () {
        this.$emit('change', this.completed)
      }
    }
  }
</script>

<style lang='scss' scoped>
  .input-up-video{
    border: 1px dashed #c2cfd6;
    border-radius: 0.25rem;
  }
  .up-video-progress-bar{
    position: relative;
    span.name{
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        color: #fff;
      }
    .up-video-progress-uploading{
      position: absolute;
      height: 100%;
      top: 0;
      left: 0;
      width: 0;
      background: #48a6f0;
    }
    .up-video-progress-success{
      position: absolute;
      height: 100%;
      top: 0;
      left: 0;
      width: 0;
      background: #26dad2;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components-base/components-custom/up-video/ugc-uploader.vue